// extracted by mini-css-extract-plugin
module.exports = {"title":"e_Lg","container":"e_Mg","right":"e_Ng","image":"e_Og","scoreLine":"e_Pg","scoreRing":"e_Qg","badge":"e_Rg","badgeImage":"e_Sg","badgeRing":"e_Tg","large":"e_Ug"};